import instance from './instance'


const competitionURL = import.meta.env.VITE_COMPETITION_SERVER_URL

/**
 * 대회정보 가져오기
 */
interface CompetitionDTO {
  id: number
  title: string
  temperature: number
  temperatureType: number
  humidity: number
  hardness: number
  altitude: number
  altitudeType: number
  distType: number
  gender: number // -1: 남자, 여자, 0: 남자, 1: 여자, 2: 혼성
  playTime: number
  startDate: string
  endDate: string
  rule: string
}

export const fetchCompetition = async (competitionID: number) => {
  const response = await instance.get<CompetitionDTO>(
    `${competitionURL}/competitions/${competitionID}`
  )

  return response.data
}

export interface CompetitionPrize {
  id?: number
  rank?: number
  prizeName?: string
}

export const fetchCompetitionPrizes = async (competitionID: number) => {
  const response = await instance.get<CompetitionPrize[]>(
    `${competitionURL}/competitions/${competitionID}/competitionPrizes`
  )

  return response.data
}

/**
 * 대회 요약 가져오기
 */
interface CompetitionSummary {
  giveupCnt?: number | string
  playCnt?: number | string
  shopCnt?: number | string
  userCnt?: number | string
}
export const fetchCompetitionSummary = async (competitionID: number) => {
  const response = await instance.get<CompetitionSummary>(
    `${competitionURL}/competitions/${competitionID}/summary`
  )

  return response.data
}

/**
 * 랭킹 가져오기
 */
interface FetchRankingQueries {
  competitionID: number
  page: number
  limit: number
}

export type Nation = 'kr' | 'us' | 'sg' | 'jp'

interface UserRankDTO {
  id: number
  nickName: string
  nation: Nation
  shopName: string
  score: number
  rank: number
}

export interface UserRankWithAvg extends UserRankDTO {
  scoreWithAvg: string
}

interface RankingBoardDTO<T> {
  totalCount: number
  userRanks: T[]
  targetCount: number
}

export const fetchRanking = async ({
  competitionID,
  page,
  limit,
}: FetchRankingQueries): Promise<RankingBoardDTO<UserRankWithAvg>> => {
  const {
    data: { targetCount, totalCount, userRanks },
  } = await instance.get<RankingBoardDTO<UserRankDTO>>(
    `${competitionURL}/ranks/${competitionID}/realtime`,
    {
      params: { page, limit },
    }
  )

  const userRanksTable = userRanks.map((rank) => {
    const totalScore = Number(rank.score.toFixed(2))
    const average = Number((rank.score / targetCount).toFixed(1))

    return {
      ...rank,
      scoreWithAvg: `${totalScore}(${average})`,
    }
  })

  return {
    totalCount,
    targetCount,
    userRanks: userRanksTable,
  }
}
